export const COLORS = {
  GREEN: "#25B46F",
  YELLOW: "#C2B00C",
  RED: "#931A1A"
};
